import lightGallery from "lightgallery";
import "lightgallery/css/lg-thumbnail.css";
// import "lightgallery/css/lg-zoom.css"
import "lightgallery/css/lightgallery.css";
import type { GalleryItem } from "lightgallery/lg-utils";
import type { LightGallery } from "lightgallery/lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";

// import lgZoom from "lightgallery/plugins/zoom"

export interface OpenImageViewerOptions {
  id?: string;
  /**
   * @see https://www.lightgalleryjs.com/docs/dynamic-variables/
   */
  images: GalleryItem[];
  index?: number;
}

const DEFAULT_ID = "default-lightgallery";

const instances: Record<string, LightGallery> = {};

export function getImageViewer(id = DEFAULT_ID) {
  return instances[id];
}

/**
 *
 * @example
 * ```tsx
 * openImageViewer({
 *   images: [{
 *     src: 'xxx',
 *     thumb: 'xxx',
 *     alt: 'xxx',
 *   }],
 *   index,
 * })
 * ```
 * @see https://www.lightgalleryjs.com/docs/dynamic-variables/
 * @param options
 * @returns
 */
export function openImageViewer(options: OpenImageViewerOptions) {
  const { id = DEFAULT_ID, images, index = 0 } = options;

  let instance = getImageViewer(id);

  if (!instance) {
    instance = lightGallery(createEl(id), {
      dynamic: true,
      dynamicEl: images,
      index,
      plugins: [lgThumbnail],
    });
    instances[id] = instance;
  } else {
    instance.updateSlides(images, index);
  }

  instance.openGallery(index);

  return instance;
}

function createEl(id: string) {
  const el = document.createElement("div");
  el.id = id;
  document.body.appendChild(el);

  return el;
}
